export enum SectionsPreset {
    default = 'default',
    firstLecture = 'firstLecture',
}
